import _classCallCheck from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/app/jenkins-scm-48/workspace/VZW.SRE.CICD.BUILD.APPS/VZW.HCTV.vpd-fe-micro-static.Build/build/src/main/resources/templates/reactVPD/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import { jsxs as e, Fragment as t, jsx as o } from "react/jsx-runtime";
import { calculateRem as n, withVDSManager as i, checkIfMobileDevice as d, generateUUID as a } from "@vds-core/utilities";
import { Component as s, cloneElement as l, Children as r, isValidElement as u } from "react";
import { ScrollWrapper as c } from "@vds-core/scrollbars";
import p from "./ModalBase.js";
import h from "./ModalPortal.js";
var m = "undefined" != typeof window && .08 * Math.min(window && window.innerWidth, window && window.innerHeight);
var v = /*#__PURE__*/function (_s) {
  _inherits(v, _s);
  function v(e) {
    var _this;
    _classCallCheck(this, v);
    var t;
    _this = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, e)), t = _assertThisInitialized(_assertThisInitialized(_this)), _this.onUnload = function () {
      var e;
      t.state.modalOpened && (t.setState({
        modalOpened: !1
      }), !t.props.enableBackButton && t.props.onOpenedChange && t.props.onOpenedChange(!1), "undefined" != typeof window && (null === (e = window.removeEventListener) || void 0 === e || e.call(window, "popstate", t.onUnload)));
    }, _this._isKeyboardInteraction = function (e) {
      e.keyCode ? t.setState({
        isKeyboardInteraction: !0
      }) : t.setState({
        isKeyboardInteraction: !1
      });
    }, _this.registerOverride = function () {
      var e;
      t.props.enableBackButton || null === history || void 0 === history || history.pushState(null, ""), "undefined" != typeof window && (null === (e = window.addEventListener) || void 0 === e || e.call(window, "popstate", t.onUnload));
    }, _this.unRegisterOverride = function () {
      var e;
      "undefined" != typeof window && (null === (e = window.removeEventListener) || void 0 === e || e.call(window, "popstate", t.onUnload));
    }, _this.toggleModal = function () {
      var e = t.state.modalOpened,
        o = t.props.toggleButton;
      if (t.handelShowChanged(), clearTimeout(t.historyBackTimer), e) return t.setState({
        unmounted: !0
      }), t.unMountTimer = setTimeout(function () {
        var e, n, i;
        t.setState({
          modalOpened: !1
        }), o && "undefined" != typeof document && (null === (e = document.getElementById) || void 0 === e || e.call(document, t.toggleId), null === (i = null === (n = document.getElementById) || void 0 === n ? void 0 : n.call(document, t.toggleId)) || void 0 === i || i.focus());
      }, t.props.disableAnimation ? 0 : 390), t.unRegisterOverride(), void (t.historyBackTimer = setTimeout(function () {
        t.props.enableBackButton || history.back();
      }, t.props.disableAnimation ? 0 : 390));
      t.registerOverride(), t.setState({
        modalOpened: !0,
        unmounted: !1
      });
    }, _this.handelShowChanged = function () {
      var e = !t.state.modalOpened;
      t.props.onOpenedChange && t.props.onOpenedChange(e);
    }, _this.handleClick = function (e, o) {
      var n, i;
      t.toggleModal(), null === (i = null === (n = null == o ? void 0 : o.props) || void 0 === n ? void 0 : n.onClick) || void 0 === i || i.call(n, e);
    }, _this.onKeyDown = function (e, o) {
      var n, i;
      13 !== e.keyCode && 32 !== e.keyCode || (e.preventDefault(), e.stopPropagation(), null === (i = null === (n = null == o ? void 0 : o.props) || void 0 === n ? void 0 : n.onKeyDown) || void 0 === i || i.call(n, e), t.handleClick(e, o), t.setState({
        hovered: !1
      }));
    }, _this.handleMouseEnter = function () {
      t.setState({
        hovered: !0
      });
    }, _this.handleMouseLeave = function () {
      t.setState({
        hovered: !1
      });
    }, _this.renderToggle = function () {
      return t.props.toggleButton ? l(t.props.toggleButton, {
        onClick: function onClick(e) {
          return t.handleClick(e, t.props.toggleButton);
        },
        onKeyDown: function onKeyDown(e) {
          return t.onKeyDown(e, t.props.toggleButton);
        },
        onMouseEnter: t.handleMouseEnter,
        onMouseLeave: t.handleMouseLeave,
        id: t.toggleId
      }) : null;
    }, _this.state = {
      modalOpened: !1,
      unmounted: !1,
      hovered: !1,
      isKeyboardInteraction: !0
    };
    return _this;
  }
  _createClass(v, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var e, t;
      this.props.opened && (this.registerOverride(), this.setState({
        modalOpened: !0,
        unmounted: !1
      }), this.handelShowChanged()), "undefined" != typeof document && (null === (e = document.addEventListener) || void 0 === e || e.call(document, "keyup", this._isKeyboardInteraction), null === (t = document.addEventListener) || void 0 === t || t.call(document, "mousedown", this._isKeyboardInteraction));
      var o = "undefined" != typeof navigator && "MacIntel" === navigator.platform && navigator.maxTouchPoints > 1 && !Object.hasOwn(window, "MSStream"),
        n = d();
      this.isAppleDevice = /iPhone|iPad/i.test(navigator.userAgent), this.isMobileDevice = o || n, this.toggleId = "toggle-".concat(a()), this.scrollbarId = a();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(e) {
      void 0 !== this.props.opened && this.props.opened !== e.opened && this.props.opened !== this.state.modalOpened && this.toggleModal();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var e, t;
      clearTimeout(this.unMountTimer), clearTimeout(this.historyBackTimer), this.unRegisterOverride(), "undefined" != typeof document && (null === (e = document.removeEventListener) || void 0 === e || e.call(document, "keyup", this._isKeyboardInteraction), null === (t = document.removeEventListener) || void 0 === t || t.call(document, "mousedown", this._isKeyboardInteraction));
    }
  }, {
    key: "render",
    value: function render() {
      var n = this;
      var i = this.state.unmounted,
        _this$props = this.props,
        d = _this$props.ariaLabel,
        a = _this$props.disableOutsideClick,
        s = _this$props.onOpenedChange,
        v = _this$props.toggleButton,
        g = _this$props.viewport,
        f = _this$props.fullScreenDialog,
        w = _this$props.zIndex,
        b = _this$props.disableFocusLock,
        y = _this$props.id,
        B = _this$props.className,
        k = _this$props.disableAnimation,
        O = _this$props.surface,
        C = _this$props.closeButtonId,
        I = _this$props.borderRadius,
        M = _this$props.scrollThumbBorderRadius,
        S = _this$props.closeButtonFocusBorderRadius,
        T = _this$props["data-analyticstrack"],
        D = _this$props["data-track"],
        x = _this$props["data-track-ignore"],
        L = _this$props["data-clickstream"],
        K = _this$props["data-sitecat-cta"],
        E = _this$props["data-sitecat-datatrack"],
        R = _this$props["data-sitecat-position"],
        W = _this$props["data-sitecat-level"],
        A = _this$props.closeButton,
        F = _this$props.fullWidthContent,
        H = _this$props.maxHeight,
        P = _this$props.maxWidth;
      var U = -1;
      var _ = r.map(this.props.children, function (e, t) {
        var o = e;
        return o && u(o) && o.type && "ModalFooter" === o.type.displayName ? (U = t, l(o, {
          toggleModal: n.toggleModal,
          key: t + 1,
          fullWidthContent: F
        })) : o;
      });
      if (U >= 0 && null === A && this.isMobileDevice) {
        var _e = null == _ ? void 0 : _.pop();
        _e && (null == _ || _.unshift(_e));
      }
      return e(t, {
        children: [v && this.renderToggle(), this.state.modalOpened && o(h, {
          children: o(p, {
            id: y,
            disableFocusLock: b,
            zIndex: w,
            tabIndex: 0,
            ariaLabel: d,
            closeButton: A,
            disableOutsideClick: a,
            modalOpened: this.state.modalOpened,
            opened: !0,
            onOpenedChange: s,
            toggleModal: this.toggleModal,
            unmounted: i,
            modalHeight: this.props.modalHeight,
            modalWidth: this.props.width,
            isMobileDevice: this.isMobileDevice,
            isAppleDevice: this.isAppleDevice,
            viewport: g,
            fullScreenDialog: f,
            animationDistance: m,
            analyticsTrack: T,
            track: D,
            ignoreTrack: x,
            clickStream: L,
            cta: K,
            dataTrack: E,
            position: R,
            level: W,
            hovered: this.state.hovered,
            isKeyboardInteraction: this.state.isKeyboardInteraction,
            contentContainer: this.props.contentContainer,
            toggleButton: this.props.toggleButton,
            disableAnimation: k,
            surface: O,
            scrollbarId: this.scrollbarId,
            borderRadius: I,
            scrollThumbBorderRadius: M,
            ScrollWrapper: c,
            closeButtonFocusBorderRadius: S,
            closeButtonId: C,
            className: B,
            footerIndex: U,
            fullWidthContent: F,
            maxHeight: H,
            maxWidth: P,
            children: _
          })
        })]
      });
    }
  }]);
  return v;
}(s);
v.defaultProps = {
  title: void 0,
  toggleButton: void 0,
  closeButton: void 0,
  showCloseButton: void 0,
  opened: void 0,
  onOpenedChange: void 0,
  disableOutsideClick: !1,
  modalHeight: void 0,
  width: void 0,
  zIndex: 999,
  disableFocusLock: !1,
  borderRadius: n(12),
  scrollThumbBorderRadius: n(2),
  viewport: "desktop",
  fullScreenDialog: !1,
  disableAnimation: !1,
  surface: "light",
  closeButtonFocusBorderRadius: n(2),
  closeButtonId: "close-button",
  className: void 0,
  fullWidthContent: !1,
  enableBackButton: !1,
  maxHeight: "70vh",
  maxWidth: "70vw"
};
var g = i(v);
export { g as default };